/**
 * Espelha format_standard_bid_name (auto_bids.py) no cliente — fallback SSE/polling.
 */
const PARTICLES = new Set(["de", "da", "do", "dos", "das", "e"]);
const COMPOUND_FIRST = new Set([
  "ana", "maria", "joao", "joão", "luiz", "luís", "luis", "jose", "josé",
]);
const COMPOUND_SECOND = new Set([
  "clara", "eduarda", "helena", "julia", "luiza", "paula", "fernanda",
  "beatriz", "cecilia", "isabel", "lucia", "lúcia", "carolina", "alice",
]);

function titleWord(word) {
  const w = String(word || "").trim().toLowerCase();
  if (!w) return "";
  if (w.length === 1) return w.toUpperCase();
  return w[0].toUpperCase() + w.slice(1);
}

export function formatBidDisplayName(rawName, rawEmail) {
  let raw = rawName;
  if (!raw && rawEmail) raw = String(rawEmail).split("@")[0];
  if (!raw) return "Cliente VIP";

  const clean = String(raw)
    .trim()
    .replace(/[._\-+0-9]+/g, " ")
    .replace(/[^a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s]/g, " ");
  const words = clean.split(/\s+/).filter(Boolean).map(titleWord);
  if (!words.length) return "Cliente VIP";

  const significant = words.filter((w) => !PARTICLES.has(w.toLowerCase()));
  if (!significant.length) return words[0];
  if (significant.length === 1) return significant[0];

  const first = significant[0];
  const last = significant[significant.length - 1];

  if (COMPOUND_FIRST.has(first.toLowerCase())) {
    if (significant.length >= 3) {
      return `${first} ${significant[1]} ${last[0]}.`;
    }
    if (significant.length === 2) {
      const second = significant[1];
      if (COMPOUND_SECOND.has(second.toLowerCase())) return `${first} ${second}`;
      return `${first} ${second[0]}.`;
    }
  }

  if (last.toLowerCase() === first.toLowerCase()) return first;
  return `${first} ${last[0]}.`;
}

const BOT_SURNAME_POOL = "RSVMCLFBJPTANGKDFH";

/** Espelha format_bot_bid_name (auto_bids.py) — lances sintéticos sempre Nome S. */
export function formatBotBidDisplayName(rawName) {
  if (!rawName || !String(rawName).trim()) return "Participante";

  const raw = String(rawName).trim();
  const tokens = raw.split(/\s+/);
  if (tokens.length === 2) {
    const second = tokens[1].replace(/\.$/, "");
    if (second.length === 1 && /[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]/.test(second)) {
      return `${titleWord(tokens[0])} ${second.toUpperCase()}.`;
    }
  }

  const base = formatBidDisplayName(raw);
  if (!base || base === "Cliente VIP") return "Participante";

  if (base.includes(" ") && !base.endsWith(".")) {
    const parts = base.split(/\s+/);
    if (parts.length >= 2 && parts[parts.length - 1].length > 1) {
      return `${parts.slice(0, -1).join(" ")} ${parts[parts.length - 1][0]}.`;
    }
    return base;
  }

  if (!base.includes(" ")) {
    let h = 0;
    for (let i = 0; i < base.length; i += 1) h += base.toLowerCase().charCodeAt(i);
    return `${base} ${BOT_SURNAME_POOL[h % BOT_SURNAME_POOL.length]}.`;
  }

  return base;
}

export function getUserIdFromToken(token) {
  if (!token) return null;
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(json);
    return payload.sub || null;
  } catch {
    return null;
  }
}
